import {
    updateCurrentSubZoneAction,
    getLinksInPolygonAction,
    linksInPolygonsReceivedAction,
    highlightPolygonLinksAction,
    setPolygonFeaturesAction,
    getAllProposedAnalysisZonesAction,
    allProposedAnalysisZonesReceivedAction,
    setSelectedZonesAction,
    deleteSelectedZonesAction,
    copySelectedZonesAction,
    toggleFormValidatedAction,
    confirmAnalysisZoneToggleAction,
    createAnalysisZoneAndSubZonesAction,
    analysisZoneAndSubZonesCreatedAction,
    getZoneComponentsAction,
    zoneComponentsReceivedAction,
    updateZoneFiltersAction,
    editAnalysisZoneAndSubZonesAction,
    analysisZoneAndSubZonesEditedAction,
    deleteZoneComponentsAction,
    setSegmentFeaturesAction,
    highlightSegmentLinksAction,
    EXPORT_MULTIPLE_ZONES,
    exportMultipleZonesInterface,
    proposedZoneIdAction,
    toggleAnalysisZonesActionPerformedAction,
    GetDataForAnalyzerFiltersAction,
    DataForAnalyzerFiltersReceivedAction,
    SetAnalyzerFilterParamsAction
} from "./types";
import { createAction } from "@reduxjs/toolkit";

export const UPDATE_CURRENT_SUB_ZONE = "UPDATE_CURRENT_SUB_ZONE";
export const SET_SEGMENT_FEATURES = "SET_SEGMENT_FEATURES";
export const HIGHLIGHT_SEGMENT_LINKS = "HIGHLIGHT_SEGMENT_LINKS";
export const LINKS_IN_POLYGONS_RECEIVED = "LINKS_IN_POLYGONS_RECEIVED";
export const GET_LINKS_IN_POLYGON = "GET_LINKS_IN_POLYGON";
export const HIGHLIGHT_POLYGON_LINKS = "HIGHLIGHT_POLYGON_LINKS";
export const SET_POLYGON_FEATURES = "SET_POLYGON_FEATURES";
export const GET_ALL_PROPOSED_ANALYSIS_ZONES = "GET_ALL_PROPOSED_ANALYSIS_ZONES";
export const ALL_PROPOSED_ANALYSIS_ZONES_RECEIVED = "ALL_PROPOSED_ANALYSIS_ZONES_RECEIVED";
export const SET_SELECTED_ZONES = "SET_SELECTED_ZONES";
export const DELETE_SELECTED_ZONES = "DELETE_SELECTED_ZONES";
export const TOGGLE_ANALYSIS_ZONES_ACTION_PERFORMED = "TOGGLE_ANALYSIS_ZONES_ACTION_PERFORMED";
export const COPY_SELECTED_ZONES = "COPY_SELECTED_ZONES";
export const TOGGLE_FORM_VALIDATED = "TOGGLE_FORM_VALIDATED";
export const CONFIRM_ANALYSIS_ZONE_TOGGLE = "CONFIRM_ANALYSIS_ZONE_TOGGLE";
export const CREATE_ANALYSIS_ZONE_AND_SUB_ZONES = "CREATE_ANALYSIS_ZONE_AND_SUB_ZONES";
export const ANALYSIS_ZONE_AND_SUB_ZONES_CREATED = "ANALYSIS_ZONE_AND_SUB_ZONES_CREATED";
export const GET_ZONE_COMPONENTS = "GET_ZONE_COMPONENTS";
export const ZONE_COMPONENTS_RECEIVED = "ZONE_COMPONENTS_RECEIVED";
export const UPDATE_ZONE_FILTERS = "UPDATE_ZONE_FILTERS";
export const EDIT_ANALYSIS_ZONE_AND_SUB_ZONES = "EDIT_ANALYSIS_ZONE_AND_SUB_ZONES";
export const ANALYSIS_ZONE_AND_SUB_ZONES_EDITED = "ANALYSIS_ZONE_AND_SUB_ZONES_EDITED";
export const DELETE_ZONE_COMPONENTS = "DELETE_ZONE_COMPONENTS";
export const CLEAR_ZONE_COMPONENTS = "CLEAR_ZONE_COMPONENTS";
export const IS_ANALYSIS_ZONE_CHECKED = "IS_ANALYSIS_ZONE_CHECKED";
export const PROPOSED_ZONE_ID = "PROPOSED_ZONE_ID";
export const GET_DATA_FOR_ANALYZER_FILTERS = "GET_DATA_FOR_ANALYZER_FILTERS";
export const DATA_FOR_ANALYZER_FILTERS_RECEIVED = "DATA_FOR_ANALYZER_FILTERS_RECEIVED";
export const SET_ANALYZER_FILTER_PARAMS = "SET_ANALYZER_FILTER_PARAMS";

export const updateCurrentSubZone =
    createAction<updateCurrentSubZoneAction["payload"]>(UPDATE_CURRENT_SUB_ZONE);

export const getLinksInPolygon =
    createAction<getLinksInPolygonAction["payload"]>(GET_LINKS_IN_POLYGON);

export const linksInPolygonsReceived = createAction<linksInPolygonsReceivedAction["payload"]>(
    LINKS_IN_POLYGONS_RECEIVED
);

export const highlightPolygonLinks =
    createAction<highlightPolygonLinksAction["payload"]>(HIGHLIGHT_POLYGON_LINKS);

export const setPolygonFeatures =
    createAction<setPolygonFeaturesAction["payload"]>(SET_POLYGON_FEATURES);

export const getAllProposedAnalysisZones = createAction<
    getAllProposedAnalysisZonesAction["payload"]
>(GET_ALL_PROPOSED_ANALYSIS_ZONES);

export const allProposedAnalysisZonesReceived = createAction<
    allProposedAnalysisZonesReceivedAction["payload"]
>(ALL_PROPOSED_ANALYSIS_ZONES_RECEIVED);
export const setSelectedZones = createAction<setSelectedZonesAction["payload"]>(SET_SELECTED_ZONES);

export const deleteSelectedZones =
    createAction<deleteSelectedZonesAction["payload"]>(DELETE_SELECTED_ZONES);

export const toggleAnalysisZonesActionPerformed = createAction<
    toggleAnalysisZonesActionPerformedAction["payload"]
>(TOGGLE_ANALYSIS_ZONES_ACTION_PERFORMED);

export const copySelectedZones =
    createAction<copySelectedZonesAction["payload"]>(COPY_SELECTED_ZONES);

export const toggleFormValidated =
    createAction<toggleFormValidatedAction["payload"]>(TOGGLE_FORM_VALIDATED);

export const confirmAnalysisZoneToggle = createAction<confirmAnalysisZoneToggleAction["payload"]>(
    CONFIRM_ANALYSIS_ZONE_TOGGLE
);

export const createAnalysisZoneAndSubZones = createAction<
    createAnalysisZoneAndSubZonesAction["payload"]
>(CREATE_ANALYSIS_ZONE_AND_SUB_ZONES);

export const analysisZoneAndSubZonesCreated = createAction<
    analysisZoneAndSubZonesCreatedAction["payload"]
>(ANALYSIS_ZONE_AND_SUB_ZONES_CREATED);

export const getZoneComponents =
    createAction<getZoneComponentsAction["payload"]>(GET_ZONE_COMPONENTS);

export const proposedZoneId = createAction<proposedZoneIdAction["payload"]>(PROPOSED_ZONE_ID);

export const zoneComponentsReceived =
    createAction<zoneComponentsReceivedAction["payload"]>(ZONE_COMPONENTS_RECEIVED);

export const updateZoneFilters =
    createAction<updateZoneFiltersAction["payload"]>(UPDATE_ZONE_FILTERS);

export const editAnalysisZoneAndSubZones = createAction<
    editAnalysisZoneAndSubZonesAction["payload"]
>(EDIT_ANALYSIS_ZONE_AND_SUB_ZONES);

export const analysisZoneAndSubZonesEdited = createAction<
    analysisZoneAndSubZonesEditedAction["payload"]
>(ANALYSIS_ZONE_AND_SUB_ZONES_EDITED);

// delete zone components permanently
export const deleteZoneComponents =
    createAction<deleteZoneComponentsAction["payload"]>(DELETE_ZONE_COMPONENTS);

// clear the components from the store
export const clearZoneComponents = createAction(CLEAR_ZONE_COMPONENTS);

export const setSegmentFeatures =
    createAction<setSegmentFeaturesAction["payload"]>(SET_SEGMENT_FEATURES);

export const highlightSegmentLinks =
    createAction<highlightSegmentLinksAction["payload"]>(HIGHLIGHT_SEGMENT_LINKS);

export const exportMultipleZones =
    createAction<exportMultipleZonesInterface["payload"]>(EXPORT_MULTIPLE_ZONES);

//List view

export const getDataForAnalyzerFilters = createAction<GetDataForAnalyzerFiltersAction["payload"]>(
    GET_DATA_FOR_ANALYZER_FILTERS
);

export const dataForAnalyzerFiltersReceived = createAction<
    DataForAnalyzerFiltersReceivedAction["payload"]
>(DATA_FOR_ANALYZER_FILTERS_RECEIVED);

export const setAnalyzerFilterParams = createAction<SetAnalyzerFilterParamsAction["payload"]>(
    SET_ANALYZER_FILTER_PARAMS
);
